(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mg-footer-menu-column"] && !Shopify.designMode) return;
  try {
    (() => {
    if (!window.__mgAcsbTriggerBound) {
      window.__mgAcsbTriggerBound = true;
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-acsb-custom-trigger]');
        if (!trigger) return;
        event.preventDefault();
      });
    }

    if (!window.__mgCookieSettingsBound) {
      window.__mgCookieSettingsBound = true;
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest(
          '[data-cookie-settings-trigger], a[href$="#cookie-settings"]'
        );
        if (!trigger) return;
        event.preventDefault();

        const managePrefsButton = document.querySelector(
          '#shopify-pc__banner__btn-manage-prefs'
        );
        if (managePrefsButton) {
          managePrefsButton.click();
          return;
        }

        if (
          window.OneTrust &&
          typeof window.OneTrust.ToggleInfoDisplay === 'function'
        ) {
          window.OneTrust.ToggleInfoDisplay();
        }
      });
    }

    const currentPath = window.location.pathname;
    if (window.__mgFooterMarketizedLinksBoundPath === currentPath) return;

    const isUk = window.location.pathname.startsWith('/en-gb');
    if (!isUk) return;

    const applyFooterLinkMarketization = () => {
      if (window.__mgFooterMarketizedLinksBoundPath === currentPath) return;
      window.__mgFooterMarketizedLinksBoundPath = currentPath;

      const createCookieSettingsItem = (listItemClass) => {
        const li = document.createElement('li');
        li.className = listItemClass;

        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'menu__cookie-settings-button';
        button.setAttribute('data-cookie-settings-trigger', '');
        button.textContent = 'cookie settings';

        li.appendChild(button);
        return li;
      };

      document.querySelectorAll('.footer-content--brand nav.details-content').forEach((nav) => {
        const linkItems = [...nav.querySelectorAll('li.menu__item')];
        const doNotSellLink = linkItems.find((item) => {
          const anchor = item.querySelector('a');
          return anchor && anchor.textContent.trim().toLowerCase() === 'do not sell my information';
        });

        if (!doNotSellLink) return;

        const list = nav.querySelector('ul.list-unstyled');
        if (!list) return;

        doNotSellLink.remove();

        const hasCookieSettings = !!list.querySelector('[data-cookie-settings-trigger]');
        if (!hasCookieSettings) {
          const listItemClass = doNotSellLink.className || 'menu__item';
          list.appendChild(createCookieSettingsItem(listItemClass));
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyFooterLinkMarketization, { once: true });
    } else {
      window.requestAnimationFrame(applyFooterLinkMarketization);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
